import { Accordion, AccordionItem, Col, Collapse, Row } from 'reactstrap';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { formatUSD } from '../../../../../../helpers/helpers';
import {
  getMinaraInfo,
  getU1AcademyInfo,
  getUnicaPayInfo
} from '../../../slice';

import { MinaraHub } from '../MinaraHub';
import { U1AcademyHub } from '../U1AcademyHub';

export const U1Academy = () => {
  const { loading, u1academy } = useAppSelector((state) => state.userDetails);

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getU1AcademyInfo(Number(userId)));
  }, [dispatch]);

  return (
    <div>
      <div className='accordion-body'>
        {u1academy?.map((data, i) => (
          <U1AcademyHub key={i} data={data} />
        ))}
      </div>
    </div>
  );
};
